import { createFileRoute } from "@tanstack/react-router";
import { QuestionPage } from "@/components/site/question-page";
import { faqJsonLd, localBusinessJsonLd } from "@/components/site/jsonld";
import { SITE } from "@/lib/site";
import { SPORSMAL_SIDER } from "@/lib/sporsmal";

const S = SPORSMAL_SIDER.find((p) => p.slug === "skifte-dekk-drammen")!;
const URL = `${SITE.url}/skifte-dekk-drammen`;

export const Route = createFileRoute("/skifte-dekk-drammen")({
  head: () => ({
    meta: [
      { title: S.title },
      { name: "description", content: S.desc },
      { property: "og:title", content: S.title },
      { property: "og:description", content: S.desc },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(localBusinessJsonLd()) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd([{ q: S.sporsmal, a: S.svar }, ...S.oppfolging])) },
    ],
  }),
  component: () => <QuestionPage side={S} />,
});
